import React from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '@this/components/shared/footer/footer';
import { UserSignInArea } from '@this/components/user_signin/user_signin';
import { BodyLogo, LogoContainer, UserSignInBody } from '@this/components/user_signin/user_signin_body';
import { FormContainer } from '@this/components/user_signin/user_signin_form';
import Header from '@this/components/user_signin/user_signin_header';
import { Alert } from '@this/shared/ui/feedbacks/alert';
import { Text } from '@this/shared/ui/data_displays/typography';
import { Button } from '@this/shared/ui/inputs/button';

interface Props {
  serviceId: number;
}

const AdminGoogleSignIn: React.FC<Props> = ({ serviceId }) => {
  const params = new URLSearchParams(window.location.search);
  const errorType = params.get('error_type');
  const notice = params.get('notice');

  return (
    <UserSignInArea>
      <Helmet>
        <title>管理者ログイン</title>
      </Helmet>
      <Header />
      <UserSignInBody>
        <div>
          <LogoContainer>
            <BodyLogo />
          </LogoContainer>
          <FormContainer>
            <div style={{ marginBottom: 8 }}>
              <Text bold>管理者ログイン</Text>
            </div>
            {notice === 'email_changed' ? (
              <div style={{ marginBottom: 8 }}>
                <Alert variant="success">
                  管理者の情報を更新しました。新しいメールアドレスのGoogleアカウントでログインしてください。
                </Alert>
              </div>
            ) : null}
            {errorType === 'not_registered' ? (
              <div style={{ marginBottom: 8, textAlign: 'center' }}>
                <Text color="danger">
                  ログインに失敗しました。
                  <br />
                  登録されていないユーザです。
                </Text>
              </div>
            ) : null}
            <div style={{ marginBottom: 8 }}>
              <Text level="caption">
                管理者マスタに登録されたメールアドレスのGoogleアカウントでログインしてください
              </Text>
            </div>
            <Button className="signin-button" href="/admins/auth/google" isExternal fullWidth>
              Googleでログイン
            </Button>
          </FormContainer>
        </div>
      </UserSignInBody>
      <Footer signedIn={false} serviceId={serviceId} />
    </UserSignInArea>
  );
};

export default AdminGoogleSignIn;
